import { Observable } from "rxjs";
import { User } from "src/app/_models/models";
import { WebServicesService } from "../webservices.service";
import { environment } from "src/environments/environment";

export class AccountApiService{
    constructor(private _ws: WebServicesService){}

    getMe(): Observable<User> {
        return this._ws.getWithoutCache(`${environment.wsBaseUrl}/api/Account/Me`);
    }
}